<template>
  <Layout>
    <PageHeader title="Configuracoes de Impressao" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h4 class="card-title mb-0">Configuracoes de Credenciamento</h4>
                <p class="text-muted mb-0">Configure opcoes de impressao de badges</p>
              </div>
              <router-link to="/badge-builder" class="btn btn-primary">
                <i class="bx bx-arrow-back"></i> Voltar
              </router-link>
            </div>

            <div class="row">
              <div class="col-md-6 col-lg-5">
                <div class="form-group">
                  <label>Método de Autenticação no Credenciamento</label>
                  <select v-model.number="settings.auth_accreditation" class="form-control">
                    <option :value="1">CPF</option>
                    <option :value="2">E-mail</option>
                  </select>
                  <small class="form-text text-muted">
                    Escolha como o participante será identificado
                  </small>
                </div>

                <div class="form-group">
                  <label class="d-flex align-items-center">
                    <input type="checkbox" v-model="settings.auto_checkin_after_credential" class="mr-2" />
                    <span>Check-in automático após credenciamento</span>
                  </label>
                  <small class="form-text text-muted">
                    Fazer check-in automaticamente após gerar badge
                  </small>
                </div>

                <div class="form-group">
                  <label>Nome do evento visível no credenciamento?</label>
                  <select v-model="settings.show_event_name" class="form-control">
                    <option :value="true">Sim</option>
                    <option :value="false">Não</option>
                  </select>
                  <small class="form-text text-muted">
                    Com "Não", o tablet mostra apenas o banner e o logo — sem o rótulo
                    "CREDENCIAMENTO", sem o nome do evento e sem o desfoque sobre a arte.
                  </small>
                </div>
              </div>

              <div class="col-md-6 col-lg-7">
                <label class="d-block mb-2">Identidade visual do credenciamento</label>
                <p class="text-muted small mb-3">
                  Banner e logo exibidos na tela de credenciamento (tablet). Ficam disponíveis offline após sincronizar.
                </p>

                <div class="row">
                  <div class="col-sm-7">
                    <div class="form-group">
                      <label class="small text-muted">Banner do evento</label>
                      <input ref="bannerInput" type="file" accept="image/*" class="d-none" @change="onPick($event, 'banner')" />
                      <div class="upload-box upload-box--banner" @click="$refs.bannerInput.click()">
                        <img v-if="settings.banner" :src="settings.banner" alt="banner" />
                        <div v-else class="upload-empty">
                          <i class="bx bx-image-add"></i>
                          <span>Enviar banner</span>
                        </div>
                      </div>
                      <div class="upload-actions">
                        <button type="button" class="btn btn-sm btn-light" @click="$refs.bannerInput.click()">
                          <i class="bx bx-upload"></i> {{ settings.banner ? 'Trocar' : 'Enviar' }}
                        </button>
                        <button v-if="settings.banner" type="button" class="btn btn-sm btn-link text-danger" @click="clearImage('banner')">
                          Remover
                        </button>
                      </div>
                      <small class="form-text text-muted">Recomendado: 1920×580px (paisagem).</small>
                    </div>
                  </div>

                  <div class="col-sm-5">
                    <div class="form-group">
                      <label class="small text-muted">Logo do evento</label>
                      <input ref="logoInput" type="file" accept="image/*" class="d-none" @change="onPick($event, 'logo')" />
                      <div class="upload-box upload-box--logo" @click="$refs.logoInput.click()">
                        <img v-if="settings.logo" :src="settings.logo" alt="logo" />
                        <div v-else class="upload-empty">
                          <i class="bx bx-image-add"></i>
                          <span>Enviar logo</span>
                        </div>
                      </div>
                      <div class="upload-actions">
                        <button type="button" class="btn btn-sm btn-light" @click="$refs.logoInput.click()">
                          <i class="bx bx-upload"></i> {{ settings.logo ? 'Trocar' : 'Enviar' }}
                        </button>
                        <button v-if="settings.logo" type="button" class="btn btn-sm btn-link text-danger" @click="clearImage('logo')">
                          Remover
                        </button>
                      </div>
                      <small class="form-text text-muted">PNG transparente, ~300px.</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-2">
              <button class="btn btn-primary" @click="saveSettings" :disabled="saving">
                <i class="bx" :class="saving ? 'bx-loader-alt bx-spin' : 'bx-save'"></i>
                {{ saving ? 'Salvando...' : 'Salvar Configurações' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import { successMessage, errorMessage } from '@/components/alertsMessages'
import * as services from './services'

export default {
  name: 'BadgeBuilderSettings',
  components: {
    Layout,
    PageHeader
  },
  data: function () {
    return {
      items: [
        { text: 'Eventfy', to: '/' },
        { text: 'Badge Builder', to: '/badge-builder' },
        { text: 'Configuracoes', active: true }
      ],
      loading: false,
      saving: false,
      settings: {
        id: null,
        auto_checkin_after_credential: false,
        auth_accreditation: 1,
        show_event_name: true,
        banner: '',
        logo: ''
      },
      bannerFile: null,
      logoFile: null
    }
  },
  mounted: function () {
    this.loadSettings()
  },
  methods: {
    loadSettings: function () {
      var self = this
      self.loading = true
      services.getAccreditationSettings()
        .then(function (response) {
          var data = (response.data && response.data.data) ? response.data.data : response.data
          if (data) {
            // show_event_name ausente (evento anterior à opção) => true, o histórico.
            self.settings = Object.assign({ banner: '', logo: '', show_event_name: true }, data)
            self.settings.show_event_name = self.settings.show_event_name !== false &&
              self.settings.show_event_name !== 0 && self.settings.show_event_name !== '0'
          }
        })
        .catch(function (error) {
          console.error('Error loading settings:', error)
        })
        .finally(function () {
          self.loading = false
        })
    },
    onPick: function (e, field) {
      var file = e.target.files && e.target.files[0]
      if (!file) return

      if (file.type.indexOf('image/') === -1) {
        errorMessage('Selecione um arquivo de imagem.')
        return
      }
      if (file.size / 1024 / 1024 > 4) {
        errorMessage('Imagem muito grande (máx. 4MB).')
        return
      }

      if (field === 'banner') this.bannerFile = file
      if (field === 'logo') this.logoFile = file

      var self = this
      var reader = new FileReader()
      reader.onload = function (ev) {
        self.settings[field] = ev.target.result
      }
      reader.readAsDataURL(file)
    },
    clearImage: function (field) {
      this.settings[field] = ''
      if (field === 'banner') {
        this.bannerFile = null
        if (this.$refs.bannerInput) this.$refs.bannerInput.value = ''
      }
      if (field === 'logo') {
        this.logoFile = null
        if (this.$refs.logoInput) this.$refs.logoInput.value = ''
      }
    },
    saveSettings: function () {
      var self = this
      self.saving = true

      var form = new FormData()
      form.append('id', self.settings.id || 1)
      form.append('auth_accreditation', self.settings.auth_accreditation)
      form.append('auto_checkin_after_credential', self.settings.auto_checkin_after_credential ? 1 : 0)
      form.append('show_event_name', self.settings.show_event_name ? 1 : 0)
      if (self.settings.has_auto_credential !== undefined && self.settings.has_auto_credential !== null) {
        form.append('has_auto_credential', self.settings.has_auto_credential ? 1 : 0)
      }
      if (self.settings.model_label !== undefined && self.settings.model_label !== null) {
        form.append('model_label', self.settings.model_label)
      }
      if (self.bannerFile) form.append('banner', self.bannerFile, 'event-banner.' + self.ext(self.bannerFile))
      if (self.logoFile) form.append('logo', self.logoFile, 'event-logo.' + self.ext(self.logoFile))

      services.saveAccreditationSettings(form)
        .then(function (response) {
          var data = (response.data && response.data.data) ? response.data.data : response.data
          if (data) {
            if (!self.settings.id && data.id) self.settings.id = data.id
            // reflete URLs persistidas no backend
            if (data.banner) self.settings.banner = data.banner
            if (data.logo) self.settings.logo = data.logo
          }
          self.bannerFile = null
          self.logoFile = null
          successMessage('Configuracoes salvas com sucesso')
        })
        .catch(function (error) {
          console.error('Error saving settings:', error)
          errorMessage(error.message ? error.message : 'Falha ao salvar configuracoes')
        })
        .finally(function () {
          self.saving = false
        })
    },
    ext: function (file) {
      var parts = (file.name || '').split('.')
      return parts.length > 1 ? parts.pop() : 'png'
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group {
  margin-bottom: 1.5rem;

  label {
    font-weight: 500;
    margin-bottom: 0.5rem;

    input[type="checkbox"] {
      width: 18px;
      height: 18px;
    }
  }
}

.upload-box {
  border: 1px dashed #ced4da;
  border-radius: 8px;
  background: #f8f9fa;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color .15s ease;

  &:hover { border-color: #5664d2; }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &--banner { height: 130px; }
  &--logo { height: 130px; }
}

.upload-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #98a6ad;

  i { font-size: 28px; }
  span { font-size: 12px; }
}

.upload-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}
</style>
